import { useState, useRef, useEffect } from "react";
import { TextField } from "@material-ui/core";
import SingleDropDown from "../SingleDropDown";
import ToggleButtons from "./ToggleButtons";

const _spacing = "10px";

const SvqForm = props => {
  const inputLabel = useRef(null);
  const [labelWidth, setLabelWidth] = useState(0);
  const [toggleOption, setToggleOption] = useState(0);

  useEffect(() => {
    if (inputLabel.current) {
      setLabelWidth(inputLabel.current.offsetWidth);
    }
  }, []);

  const getUpdatedState = (prevState, name, value, isRegistrationScan) => {
    if (isRegistrationScan) {
      return { ...prevState, [name]: value };
    }

    if (name === "vin") {
      return {
        ...prevState,
        [name]: value,
        licensePlateNumber: null,
        year: null,
        licenseType: null,
      };
    } else {
      return { ...prevState, [name]: value, vin: null };
    }
  };

  const handleChange = e => {
    const name = e.target.name;
    const value = e.target.value;
    const newState = getUpdatedState(
      props.queryState,
      name,
      value,
      props.isRegistrationScan
    );
    props.setQueryState(newState);
  };

  const PlateYear = () => {
    return (
      <>
        {/* eslint-disable-next-line jsx-a11y/no-autofocus -- Focus the plate field for a direct query; scan results can opt out. */}
        <TextField autoFocus={props?.autoFocus !== undefined ? props?.autoFocus : true}
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          margin="dense"
          id="licensePlateNumber-id"
          label="License Plate Number"
          value={props?.queryState?.licensePlateNumber || ""}
          onChange={handleChange}
          name="licensePlateNumber"
          style={{ width: "45%" }}
        />
        <TextField
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          margin="dense"
          id="year-id"
          label="Year"
          value={props?.queryState?.year || ""}
          type="number"
          onChange={handleChange}
          name="year"
          style={{ width: "45%" }}
        />
        <SingleDropDown
          title={"License Type"}
          value={props?.queryState?.licenseType}
          stateName={"licenseType"}
          options={props.licenseTypes}
          handleChange={handleChange}
          inputLabel={inputLabel}
          labelWidth={labelWidth}
          disabled={false}
        />
      </>
    );
  };

  const Vin = () => {
    return (
      <TextField
        variant="outlined"
        InputLabelProps={{ shrink: true }}
        margin="dense"
        id="vin-id"
        label="Vehicle Identification Number"
        value={props?.queryState?.vin || ""}
        onChange={handleChange}
        name="vin"
        style={{ width: "45%" }}
        helperText="No dashes or spaces"
      />
    );
  };

  const formOptions = [PlateYear, Vin];

  return (
    <div
      data-testid="svq-form"
      id="bottom-half"
      style={{ display: "flex", flexDirection: "column", rowGap: "10px" }}
    >
      {props.children}
      <ToggleButtons
        buttons={[{ name: "Plate/Year" }, { name: "VIN" }]}
        callback={setToggleOption}
      />
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          border: "1px solid black",
          justifyContent: "space-between",
          padding: _spacing,
        }}
      >
        {formOptions[toggleOption] && formOptions[toggleOption]()}
      </div>
    </div>
  );
};

export default SvqForm;
